import { createGlobalStyle } from 'styled-components'

const theme = {
    admin: {
        colors: {
            brand: '#338ce4',
            brandDark: '#2d2d2d',
            background: '#f7f7f7',
            border: '#c8c8c8',
            heading: '#aaaaaa',
            success: '#28a745',
            warning: '#FAB955',
            danger: '#E23D56',
            greyLight: '#eeeeee',
            greyDark: '#747375',
        },
        font: {
            size: '14px',
            color: '#606060',
        },
        editor: {
            text: '#c0c0c0',
            input: '#666',
        },
        boxShadow:
            '0 0.46875rem 2.1875rem rgba(4,9,20,0.03), 0 0.9375rem 1.40625rem rgba(4,9,20,0.03), 0 0.25rem 0.53125rem rgba(4,9,20,0.05), 0 0.125rem 0.1875rem rgba(4,9,20,0.03)',
    },
}

export const GlobalStyle = createGlobalStyle`
    /* 
    * Toast Notifications
    *----------------------------------*/

    .toast-container {
        .Toastify__toast {
            font-family: 'Muli', sans-serif;
            border-radius: 3px;
            width: auto;
            margin-bottom: 0;
            margin-top: 2rem;
            font-size: 1rem;
            padding: 1rem;

            &.Toastify__toast--success {
                background-color: ${() => theme.admin.colors.success};
            }
        }
    }

`

export const AdminStyle = createGlobalStyle`
    body {
        font-family: 'Muli', sans-serif;
        font-size: ${() => theme.admin.font.size};
        color: ${() => theme.admin.font.color};
        background-color: ${() => theme.admin.colors.background};
    }

    .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
        margin-bottom: 0.5rem;
    }

    p {
        margin-bottom: 1rem;
    }
    
    .btn {
        border-radius: 3px;
        font-size: 0.9rem;
    }

    .btn-primary {
        background-color: #007bff;
    }

    .btn-success {
        background-color: #28a745;
    }

    .btn-danger {
        background-color: #dc3545;
    }

    .card {
        border: none;
        border-radius: 0px;
    }

    .card--shadow {
        box-shadow: ${() => theme.admin.boxShadow};
    }

    .card--transparent {
        background-color: transparent;

        .card-body {
            padding: 0;
        }
    }

    .brand-color {
        color: ${() => theme.admin.colors.brand};
    }

    .text-black {
        color: #212529;

        &:hover {
            color: #212529;
        }
    }

    .text-grey {
        color: ${() => theme.admin.colors.heading};
    }

    .text-link {
        color: #007bff;
    }

    .text-small {
        font-size: 75%;
    }
    
    .text-nowrap {
        white-space: nowrap;
    }

    .text-uppercase {
        text-transform: uppercase;
    }

    .overflow-anywhere {
        overflow-wrap: anywhere;
    }

    /* 
     * Form Overrides
     *----------------------------------*/

    .form-container {
        max-width: 900px;
        margin: 0 auto;   
    }

    .form-control {
        border-radius: 4px;
        border-color: hsl(0,0%,80%);
        font-weight: 300;
        font-size:0.9rem;
        min-height: calc(1.5em + .75rem + 3px);
        height: auto;

        ::placeholder {
            color: #dddddd;
        }

        &:hover {
            border-color: hsl(0,0%,70%);
        }

        &:focus {
            border-color: #2684FF;
            box-shadow: 0 0 0 1px #2684FF;
        }
    }

    .form-group {
        label {
            color: ${() => theme.admin.font.color};
            font-size: 0.85rem;
            font-weight: 500;

            &.required:after {
                content: '*';
                color: ${() => theme.admin.colors.danger};
            }
        }

        &.has-error {
            input,
            select {
                border-color: ${() => theme.admin.colors.danger};
            }

            .error-text {
                font-size: 0.75rem;
            }

            input[type="text"],
            input[type="email"],
            input[type="number"] {
                background-image: url(data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjRTIzRDU2IiBkPSJNMjU2IDhDMTE5LjA0MyA4IDggMTE5LjA4MyA4IDI1NmMwIDEzNi45OTcgMTExLjA0MyAyNDggMjQ4IDI0OHMyNDgtMTExLjAwMyAyNDgtMjQ4QzUwNCAxMTkuMDgzIDM5Mi45NTcgOCAyNTYgOHptMCA0NDhjLTExMC41MzIgMC0yMDAtODkuNDMxLTIwMC0yMDAgMC0xMTAuNDk1IDg5LjQ3Mi0yMDAgMjAwLTIwMCAxMTAuNDkxIDAgMjAwIDg5LjQ3MSAyMDAgMjAwIDAgMTEwLjUzLTg5LjQzMSAyMDAtMjAwIDIwMHptNDItMTA0YzAgMjMuMTU5LTE4Ljg0MSA0Mi00MiA0MnMtNDItMTguODQxLTQyLTQyIDE4Ljg0MS00MiA0Mi00MiA0MiAxOC44NDEgNDIgNDJ6bS04MS4zNy0yMTEuNDAxbDYuOCAxMzZjLjMxOSA2LjM4NyA1LjU5MSAxMS40MDEgMTEuOTg1IDExLjQwMWg0MS4xN2M2LjM5NCAwIDExLjY2Ni01LjAxNCAxMS45ODUtMTEuNDAxbDYuOC0xMzZjLjM0My02Ljg1NC01LjEyMi0xMi41OTktMTEuOTg1LTEyLjU5OWgtNTQuNzdjLTYuODYzIDAtMTIuMzI4IDUuNzQ1LTExLjk4NSAxMi41OTl6Ij48L3BhdGg+PC9zdmc+);
                background-position: right 10px center;
                background-repeat: no-repeat;
                background-size: 20px;
            }
        }
    }

    .input-group-prepend {
        margin-right: 0px;

        .input-group-text {
            border-radius: 0px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            border-right: none;
            font-size: 0.9rem;
            color: ${() => theme.admin.font.color};
            background-color: #eee;
        }

        + .form-control {
            border-left: none;
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
        }
    }

    .input-group-append {
        margin-left: 0px;

        .input-group-text {
            border-radius: 0px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border-left: none;
            font-size: 0.9rem;
            color: ${() => theme.admin.font.color};
            background-color: #eee;
        }
    }

    /* Prevents the save panel overlapping Select items when the Select's at the bottom of the form */
    [class$="-container"] {
        
        .list__menu {
            z-index: 100;
        }

        [class$="-control"] + [class$="-menu"] {
           margin-bottom: 70px !important;
        }
    }
    
    table {
        .form-group {
            margin-bottom: 0;
        }
        
        &.table {
            tbody {
                td {
                    vertical-align: middle;
                }
            }
        }

        a {
            color: #007bff;
        }
    }

    .help-text {
        font-size: 0.8rem;
        font-weight: 300;
    }

    .z-1 {
        z-index: 1;
    }

    .z-2 {
        z-index: 2;
    }

    .z-3 {
        z-index: 3;
    }

    .ck {
        &.ck-content {
            ul,
            ol {
                padding-left: 40px;
            }

            ul{
                list-style: disc;
            }

            ol {
                list-style: number;
            }
        }
    }

    /* 
     * Tooltips
     *----------------------------------*/
    [data-tooltip] {
        position: relative;
        cursor: pointer;
        z-index: 9999999;
    }
    [data-tooltip]:before,
    [data-tooltip]:after {
        line-height: 1;
        font-size: .9em;
        pointer-events: none;
        position: absolute;
        box-sizing: border-box;
        display: none;
        opacity: 0;
    }
    [data-tooltip]:before {
        content: "";
        border: 5px solid transparent;
        z-index: 100;
    }
    [data-tooltip]:after {
        content: attr(data-tooltip);
        text-align: center;
        min-width: 3em;
        max-width: 21em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 7px 7px;
        border-radius: 3px;
        background: #333333;
        color: #FFFFFF;
        z-index: 99;
    }
    .tooltip-wrap[data-tooltip]:after {
        white-space: normal;
        min-width: 200px;
        line-height: 1.3;
    }
    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
        display: block;
        opacity: 1;
    }
    [data-tooltip]:not([data-flow]):not(.tooltip-below)::before,
    [data-tooltip]:not(.tooltip-below)::before {
        bottom: 100%;
        border-bottom-width: 0;
        border-top-color: #333333;
    }

    [data-tooltip]:not([data-flow]):not(.tooltip-below)::after,
    [data-tooltip]:not(.tooltip-below)::after {
        bottom: calc(100% + 5px);
    }

    .tooltip-below[data-tooltip]:not([data-flow])::before,
    .tooltip-below[data-tooltip]::before {
        top: 100%;
        border-top-width: 0;
        border-bottom-color: #333333;
    }
    .tooltip-below[data-tooltip]:not([data-flow])::after,
    .tooltip-below[data-tooltip]::after {
        top: calc(100% + 5px);
    }
    [data-tooltip]:not([data-flow])::before, [tooltip]:not([data-flow])::after,
    [data-tooltip]::before,
    [data-tooltip]::after {
        left: 50%;
        -webkit-transform: translate(-50%, -4px);
                transform: translate(-50%, -4px);
    }
    [data-tooltip=""]::after, [data-tooltip=""]::before {
        display: none !important;
    }

    /* 
     * Forn Dashboard Tables
     *----------------------------------*/

    .dashboard-table {
        background: #ffffff;
        border: 1px solid #DEE2E6;
        border-bottom: 0;
        margin-bottom: 30px;
        min-width: 850px;
    }
    .table-column {
        border-bottom: 1px solid #DEE2E6;
        display: flex;
        fontSize: 14px;
        flexWrap: wrap;
        padding: 15px;

        .header {
            font-size: 26px;
            font-weight: 200;
            width: 80%;
        }
        .view-all {
            margin-top: 10px;
            text-align: right;
            width: 20%;
        }
        .pill {
            background-color: #28a745;
            border-radius: 10rem;
            color: #ffffff;
            padding-left: 0.63em;
            width: 60px;
        }
    }

`

export default theme
